var map = {
	"./bus.jpg": "230f",
	"./car.jpg": "6b9c",
	"./food.jpg": "212b",
	"./hotel.jpg": "69c8",
	"./meeting.jpg": "05b6",
	"./museum.jpg": "1623",
	"./other.jpg": "4507",
	"./plane.jpg": "c2d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";